import { UserRoleObject } from '../user-role-object';
import { getAccessScopesByUserRoleName } from './getAccessScopesByUserRoleName';
import { removeRedundantAccessScopes } from './removeRedundantAccessScopes';

export const getAccessScopesByUserRoleNames = (userRoleNames: string[], userRoles: UserRoleObject[]) => {
  const accessScopes = userRoleNames.reduce(
    (acc, current) => [...acc, ...getAccessScopesByUserRoleName(current, userRoles)],
    [],
  );

  return removeRedundantAccessScopes(accessScopes);
};
